export const HOME = { emergentLink: "emergent-link" };

export const AUTH = {
  loginForm: "login-form",
  emailInput: "login-email-input",
  passwordInput: "login-password-input",
  submitBtn: "login-submit-button",
};

export const PALLET = {
  createBtn: "create-pallet-button",
  nameInput: "pallet-name-input",
  confirmCreate: "confirm-create-pallet",
  deleteBtn: (id) => `delete-pallet-${id}`,
  card: (id) => `pallet-card-${id}`,
  showAllToggle: "show-all-pallets-toggle",
};

export const ITEM = {
  addBtn: "add-item-button",
  scanBtn: "scan-barcode-button",
  searchInput: "product-search-input",
  quantityInput: "item-quantity-input",
  confirmAdd: "confirm-add-item",
  deleteBtn: (id) => `delete-item-${id}`,
};

export const DISTRIBUTION = {
  storeSelect: "dist-store-select",
  quantityInput: "dist-quantity-input",
  addBtn: "dist-add-button",
};

export const BOX = {
  createBtn: "create-box-button",
  nameInput: "box-name-input",
  storeSelect: "box-store-select",
  weightInput: "box-weight-input",
  lengthInput: "box-length-input",
  widthInput: "box-width-input",
  heightInput: "box-height-input",
  saveBtn: "save-box-button",
};

export const LANG_TOGGLE = "language-toggle-button";
export const THEME_TOGGLE = "theme-toggle-button";
export const LOGOUT_BTN = "logout-button";
